(function (root) {
  const strings = root.document ? JSON.parse(root.document.getElementById('halo-script-strings').textContent) : require('../locales/en.default.json').javascript;
  function text(key, values = {}) {
    let value = (strings[key] || key).replace(/\{\{\s*(\w+)\s*\}\}/g, '[$1]');
    for (const [name, replacement] of Object.entries(values)) value = value.replaceAll('[' + name + ']', String(replacement));
    return value;
  }
  function parseOfferDeadline(value) {
    const parts = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/);
    if (!parts) return null;
    const [, yearText, monthText, dayText, hourText, minuteText, secondText = '0', fractionText = '', zone] = parts;
    const [year, month, day, hour, minute, second] = [yearText, monthText, dayText, hourText, minuteText, secondText].map(Number);
    const fraction = Number(`0${fractionText}`) * 1000;
    if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate() || hour > 23 || minute > 59 || second > 59) return null;
    const offsetHour = zone === 'Z' ? 0 : Number(zone.slice(1, 3));
    const offsetMinute = zone === 'Z' ? 0 : Number(zone.slice(4, 6));
    if (offsetHour > 14 || offsetMinute > 59 || offsetHour === 14 && offsetMinute !== 0) return null;
    const offset = (offsetHour * 60 + offsetMinute) * (zone[0] === '+' ? 1 : -1);
    const date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    date.setUTCHours(hour, minute, second, fraction);
    const timestamp = date.getTime() - offset * 60_000;
    return Number.isNaN(timestamp) ? null : timestamp;
  }
  root.HaloText = text;
  root.HaloOfferDeadline = { parse: parseOfferDeadline };
  if (typeof module !== 'undefined') { module.exports = text; module.exports.parseOfferDeadline = parseOfferDeadline; }
  if (!root.document) return;
  let cartRequest = 0;
  async function refreshCartCount() {
    const link = document.querySelector('[data-halo-cart-link]');
    if (!link) return;
    const request = ++cartRequest;
    try {
      const response = await fetch(link.dataset.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== cartRequest || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-halo-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
      document.querySelectorAll('[data-halo-cart-summary]').forEach(node => {
        node.textContent = cart.item_count === 1 ? node.dataset.one : node.dataset.many.replace('[count]', String(cart.item_count));
      });
    } catch (_) { /* Keep the server-rendered count when the cart service is unavailable. */ }
  }
  root.addEventListener('pageshow', refreshCartCount);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCartCount(); });
  document.addEventListener('halo:cart:updated', refreshCartCount);
  document.addEventListener('shopify:section:load', refreshCartCount);
  function closeMenu(nav, focus) {
    const button = nav.querySelector('[aria-controls][aria-expanded]');
    if (!button) return;
    nav.dataset.menuOpen = 'false';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = document.body.dataset.menuLabel;
    if (focus) button.focus();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.halo-menu-toggle,.menu-toggle');
    if (button) {
      const nav = button.closest('nav');
      const open = button.getAttribute('aria-expanded') !== 'true';
      nav.dataset.menuOpen = String(open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? document.body.dataset.closeLabel : document.body.dataset.menuLabel;
      if (open) document.getElementById(button.getAttribute('aria-controls'))?.querySelector('a')?.focus();
    }
    const link = event.target.closest('nav a');
    if (link) {
      const nav = link.closest('nav');
      closeMenu(nav, false);
      nav.querySelectorAll('details[open]').forEach(details => { details.open = false; });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dropdown = event.target.closest('.halo-nav-dropdown[open]');
    if (dropdown) { dropdown.open = false; dropdown.querySelector('summary').focus(); return; }
    const details = event.target.closest('details.mobile-menu,details.halo-nav-mobile');
    if (details?.open) { details.open = false; details.querySelector('summary').focus(); }
    const nav = event.target.closest('nav[data-menu-open="true"]');
    if (nav) closeMenu(nav, true);
  });
  document.querySelectorAll('nav a[href]').forEach(link => {
    const target = new URL(link.href);
    if (target.origin === location.origin && target.pathname === location.pathname && !target.hash) link.setAttribute('aria-current', 'page');
  });
})(typeof window !== 'undefined' ? window : globalThis);
